import { Phone } from "lucide-react";

export default function MobileCallButton() {
  return (
    <a
      href="tel:+33650448840"
      aria-label="Appeler FLOW au 06 50 44 88 40"
      data-testid="mobile-call-button"
      className="md:hidden fixed bottom-5 right-5 z-40 w-14 h-14 rounded-full bg-[#00AFFF] text-white shadow-lg shadow-[#00AFFF]/40 flex items-center justify-center hover:bg-[#0099DD] active:scale-95 transition-all"
    >
      <Phone size={22} strokeWidth={2.5} />
    </a>
  );
}
